var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureInPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 14,
    rx: 0.5,
    fill: "white",
    fillOpacity: 0.01,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96777 7C8.96777 6.44771 9.41549 6 9.96777 6H19.4678C20.0201 6 20.4678 6.44772 20.4678 7V11.6667C20.4678 12.219 20.0201 12.6667 19.4678 12.6667H9.96777C9.41549 12.6667 8.96777 12.219 8.96777 11.6667V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureInPicture);
export default __webpack_public_path__ + "static/media/PictureInPicture.dbe5a3dbfd4225593cb6e45c934666b0.svg";
export { ForwardRef as ReactComponent };